import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function LoginPage() {
  const { t } = useTranslation();
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const oidcError = params.get('error');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate('/');
    } catch {
      setError(t('auth.invalidCredentials'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card card">
        <h2>{t('auth.loginTitle')}</h2>

        {oidcError === 'oidc_state_missing' && <p className="error-text">{t('auth.oidcStateMissing')}</p>}
        {oidcError === 'oidc_failed' && <p className="error-text">{t('auth.oidcFailed')}</p>}

        <a className="btn" style={{ width: '100%', justifyContent: 'center' }} href="/api/auth/microsoft/login">
          {t('auth.loginWithMicrosoft')}
        </a>

        <div className="login-divider">{t('auth.or')}</div>

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>{t('auth.email')}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="form-field">
            <label>{t('auth.password')}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="error-text">{error}</p>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={submitting}>
            {t('auth.loginButton')}
          </button>
        </form>
      </div>
    </div>
  );
}
